import { ShieldCheck, ShieldAlert, HelpCircle } from "lucide-react";

/**
 * R227 (2026-10-20, user request "SELARASKAN PROFIT, MARGIN, DAN STATUS
 * KELENGKAPAN BIAYA PROYEK"): badge status kelengkapan biaya kanonis.
 * Dipakai bersama oleh Ringkasan Proyek, Monitoring Proyek, dan Cost Control.
 * Warna: complete=emerald, incomplete=amber (TIDAK pernah hijau-untung),
 * unknown=slate.
 */
const TONE = {
  complete: { cls: "bg-emerald-50 text-emerald-800 border-emerald-300", Icon: ShieldCheck },
  incomplete: { cls: "bg-amber-50 text-amber-800 border-amber-300", Icon: ShieldAlert },
  unknown: { cls: "bg-slate-100 text-slate-600 border-slate-300", Icon: HelpCircle },
};

export default function ProfitStatusBadge({ view, onClick, testid = "profit-status-badge", small = false }) {
  const status = view?.completeness?.status || "unknown";
  const label = view?.completeness?.label || "Belum Dapat Dipastikan";
  const { cls, Icon } = TONE[status] || TONE.unknown;
  const reasons = (view?.completeness?.reasons || [])
    .map((r) => r.count ? `${r.label} (${r.count} transaksi)` : r.label)
    .join("\n");
  const interactive = typeof onClick === "function";
  const Comp = interactive ? "button" : "span";
  return (
    <Comp
      type={interactive ? "button" : undefined}
      data-testid={testid}
      onClick={onClick}
      title={reasons ? `${label}\n${reasons}` : label}
      className={`inline-flex items-center gap-1 border font-semibold uppercase tracking-wider ${cls} ${small ? "px-1.5 py-0.5 text-[9px]" : "px-2 py-0.5 text-[10px]"} ${interactive ? "hover:brightness-95 cursor-pointer" : ""}`}
    >
      <Icon size={small ? 9 : 11} /> {label}
    </Comp>
  );
}
